// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NewCategoryPage_NewCategoryPage__OqzDa .NewCategoryPage_BackButton__dMMRr {
  margin: 0 0 10px;
}
.NewCategoryPage_NewCategoryPage__OqzDa .NewCategoryPage_Button__Iq_G0 {
  margin: 30px 0 0;
}`, "",{"version":3,"sources":["webpack://./src/components/NewCategoryPage/NewCategoryPage.module.scss"],"names":[],"mappings":"AACI;EACI,gBAAA;AAAR;AAGI;EACI,gBAAA;AADR","sourcesContent":[".NewCategoryPage {\n    .BackButton {\n        margin: 0 0 10px;\n    }\n\n    .Button {\n        margin: 30px 0 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"NewCategoryPage": `NewCategoryPage_NewCategoryPage__OqzDa`,
	"BackButton": `NewCategoryPage_BackButton__dMMRr`,
	"Button": `NewCategoryPage_Button__Iq_G0`
};
export default ___CSS_LOADER_EXPORT___;
